import React from 'react';
import { designSystem } from '@yola/ws-ui';
import { i18next } from '@yola/ws-sdk';
import segment from 'src/js/modules/analytics/segment';
import onlinestore from '../../onlinestore';

const { EditorHeader } = designSystem;

const {
  trackers: { trackAsyncEvent },
  constants: { events },
} = segment;

function OnlineStoreTrigger() {
  const onOnlineStoreTriggerClick = () => {
    trackAsyncEvent(events.ONLINE_STORE_TRIGGER_CLICKED).then(() =>
      onlinestore.helpers.redirectToStore()
    );
  };

  return (
    <EditorHeader.NavItem onMouseDown={onOnlineStoreTriggerClick} label={i18next.t('Store')} />
  );
}

export default OnlineStoreTrigger;
